import type {AiSearchTableEntityType} from 'analytics/aiSearchAnalytics';
import {createContext, useContext} from 'react';

export type AiSearchTableLinkClickProps = {
  entityType: AiSearchTableEntityType;
  columnKind: string;
  path: string;
};

export type AiSearchTableAnalyticsContextValue = {
  toolName?: string;
  onLinkClick?: (props: AiSearchTableLinkClickProps) => void;
};

export const AiSearchTableAnalyticsContext = createContext<AiSearchTableAnalyticsContextValue>({});

export const useAiSearchTableAnalytics = () => useContext(AiSearchTableAnalyticsContext);
